module.exports = __webpack_public_path__ + "img/html.2e48b310.png";